const CommunityOverview = () =>
  import(
    /* webpackChunkName: "CommunityViews" */ '../views/community/CommunityOverview.vue'
    );

const PeopleOverview = () =>
  import(
    /* webpackChunkName: "CommunityViews" */ '../views/community/PeopleOverview.vue'
    );

const ActivityOverview = () =>
  import(
    /* webpackChunkName: "CommunityViews" */ '../views/community/ActivityOverview.vue'
    );

export const routeCommunity = [
  {
    path: 'community',
    name: 'CommunityOverview',
    component: CommunityOverview,
    redirect: 'community/activity',
    children: [
      {
        path: 'activity',
        name: 'ActivityOverview',
        component: ActivityOverview,
        meta: {
          title: 'Activity'
        }
      },
      {
        path: 'people',
        name: 'PeopleOverview',
        component: PeopleOverview,
        meta: {
          title: 'People'
        }
      }
    ]
  }
];
